// Slug → modern line icon (Lucide, inlined in utils/icons). Used on the quiz hub cards
// and result hero in place of emojis for a cleaner, premium look. Icons render as
// inline SVG (currentColor), so styling/sizing is controlled in Quiz.css.
import { LuSparkles, LuMoon, LuFlame, LuSprout, LuFlower2, LuOrbit, LuShield, LuLeaf } from "../utils/icons";

const ICONS = {
  dosha: LuSparkles,
  sleep: LuMoon,
  stress: LuFlame,
  gut: LuSprout,
  hormones: LuFlower2,
  "tcm-element": LuOrbit,
  immune: LuShield,
};

export const getQuizIcon = (slug) => ICONS[slug] || LuLeaf;

export default getQuizIcon;
